module.exports = "lui-radiobutton input{display:none}"


//////////////////
// WEBPACK FOOTER
// ./packages/lui-radiobutton/theme/lui-radiobutton.global.scss
// module id = 294
// module chunks = 0 1 15